import Component from 'irep/modules/component';
class BugMeBar extends Component {
    constructor(id, leftButtonId, rightButtonId) {
        super(id);
        this.closeButton = this.$component.find('.close-button');
        if (leftButtonId !== undefined) {
            this.leftButton = this.$component.find(leftButtonId);
        }
        if (rightButtonId !== undefined) {
            this.rightButton = this.$component.find(rightButtonId);
        }
    }
    closeMe() {
        this.closeButton.trigger('click');
    }
}
export class TechCheck extends BugMeBar {
    constructor(id, leftButtonId, rightButtonId) {
        super(id, leftButtonId, rightButtonId);
        const settingName = 'BugMeBar.TechCheck' + getCurrentQuarter().join('Q') + 'Closed';
        function getCurrentQuarter() {
            const d = new Date();
            const m = Math.floor(d.getMonth() / 3) + 1;
            const y = d.getFullYear();
            return [y, m];
        }
        this.closeButton.on('click', () => {
            window.irep.track("BugMeBar", settingName, 'closed', '', '');
            window.irep.getHtml({ type: "POST", url: "api/knowledgeExam/setTechCheckSetting", data: { setting: { name: settingName, value: 'true' } } });
        });
        this.rightButton.on('click', () => {
            window.irep.track("BugMeBar", settingName, 'snoozed', '', '');
            window.irep.getHtml({ type: "POST", url: "api/knowledgeExam/setTechCheckSetting", data: { setting: { name: settingName, value: 'snooze' } } });
        });
    }
}
export class DemographicsSurvey extends BugMeBar {
    constructor(id, leftButtonId, rightButtonId) {
        super(id, leftButtonId, rightButtonId);
        const settingName = 'BugMeBar.DemographicsSurvey';
        this.closeButton.on('click', () => {
            window.irep.track("BugMeBar", settingName, 'closed', '', '');
            window.irep.getHtml({ type: "POST", url: "api/participant/setting", data: { setting: { name: settingName, value: 'true' } } });
        });
        this.rightButton.on('click', () => {
            window.irep.track("BugMeBar", settingName, 'snoozed', '', '');
            window.irep.getHtml({ type: "POST", url: "api/participant/setting", data: { setting: { name: settingName, value: 'snooze' } } });
        });
    }
}
